const NotFound = () =>{
    return (
        <>
            잘못된 페이지
        </>
    )
}

export default NotFound